var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 1C9.3335 1 11.1668 1.16667 13.5002 3.5C15.8335 5.83333 16.0002 7.66667 16.0002 7.66667",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50586 3.94629C9.50586 3.94629 10.3308 4.18199 11.5683 5.41943C12.8057 6.65687 13.0414 7.48182 13.0414 7.48182",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03132 3.7638L6.57217 4.73291C7.06025 5.60748 6.86432 6.75476 6.09559 7.52349C6.09559 7.52349 6.09559 7.52349 6.09559 7.52349C6.09548 7.52361 5.16325 8.45605 6.85376 10.1466C8.54361 11.8364 9.47602 10.9055 9.47683 10.9047C9.47686 10.9047 9.47684 10.9047 9.47687 10.9047C10.2456 10.136 11.3929 9.94008 12.2674 10.4282L13.2365 10.969C14.5571 11.706 14.7131 13.558 13.5523 14.7188C12.8548 15.4163 12.0003 15.9591 11.0558 15.9949C9.46565 16.0551 6.76523 15.6527 4.05642 12.9439C1.34761 10.2351 0.945179 7.53468 1.00546 5.94456C1.04127 4.99999 1.584 4.14552 2.2815 3.44802C3.4423 2.28723 5.29431 2.44319 6.03132 3.7638Z",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.bc0a22e808123ef97fd55a6650fd2a56.svg";
export { ForwardRef as ReactComponent };